import { render, staticRenderFns } from "./SingleJournalByYearTables.vue?vue&type=template&id=45636ff8&scoped=true"
import script from "./SingleJournalByYearTables.vue?vue&type=script&lang=js"
export * from "./SingleJournalByYearTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45636ff8",
  null
  
)

export default component.exports